import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCall from "../../api/apiCall";

const tokenFinder = () => {
  if (JSON.parse(localStorage.getItem("userInfo"))) {
    return JSON.parse(localStorage.getItem("userInfo"));
  } else {
    return "";
  }
};

export const asyncCheckUser = createAsyncThunk(
  "staff/asyncCheackUser",
  async (credential) => {
    const response = await apiCall.post(`staff/userver`, credential, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  }
);

export const asyncCheckOTP = createAsyncThunk(
  "staff/asyncCheackOTP",
  async (credential) => {
    const response = await apiCall.post(`staff/otpver`, credential, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  }
);

export const asyncaddProfile = createAsyncThunk(
  "staff/asyncaddProfile",
  async (credential) => {
    const response = await apiCall.post(`staff/adduser`, {data:credential, account:tokenFinder()}, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  }
);

export const asyncActivate = createAsyncThunk(
  "staff/asyncActivate",
  async () => {
    const response = await apiCall.post(`staff/premiumactivation`, {account:tokenFinder()}, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  }
);







const initialState = {
  loginstage : 0,
  loading: false,
  error: false,
  verifiedOTp:true,
  succescase: false,
  boxloading: false,
  boxerror: false,
  passcode: null,
  wrongcredential: false,
  succes: false,
  compleated: false,
  user:{},
};
const staffSlice = createSlice({
  name: "staff",
  initialState,
  reducers: {
    setloginpage:(state) =>{
      state.loginstage=0
    },
    getToken: (state, { payload }) => {
      state.user = payload
    },
    setDefault: (state) => {
      state.succes = false;
      state.loading = false;
      state.error = false;
      state.boxloading = false;
      state.boxerror = false;
      state.wrongcredential = false;
    },
    setTimeoutComp: (state) => {
      state.compleated = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(asyncCheckUser.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(asyncCheckUser.fulfilled, (state, { payload }) => {
        state.loading = false
        state.loginstage=1
      })
      .addCase(asyncCheckUser.rejected, (state) => {
        state.error = true;
        state.loading = false
      })
      .addCase(asyncCheckOTP.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.verifiedOTp = true
      })
      .addCase(asyncCheckOTP.fulfilled, (state, { payload }) => {
        state.loading = false
        if(payload.error){
          state.error = true;
        }
        if(!payload.otp){
          state.verifiedOTp = false
        }
        if(payload.otp){
          localStorage.setItem("userInfo", JSON.stringify(payload.data))
          window.location.reload();
        }

      })
      .addCase(asyncCheckOTP.rejected, (state) => {
        state.error = true;
        state.loading = false
      })
      .addCase(asyncaddProfile.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(asyncaddProfile.fulfilled, (state, { payload }) => {
        // state.loading = false
        localStorage.setItem("userInfo", JSON.stringify(payload))
        window.location.reload();
      })
      .addCase(asyncaddProfile.rejected, (state) => {
        state.error = true;
        state.loading = false
      })
      .addCase(asyncActivate.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(asyncActivate.fulfilled, (state, { payload }) => {
        state.loading = false
        localStorage.setItem("userInfo", JSON.stringify(payload))
        state.succescase = true
      })
      .addCase(asyncActivate.rejected, (state) => {
        state.error = true;
        state.loading = false
      })

  },
});

export const { getToken, setDefault, setTimeoutComp,setloginpage } = staffSlice.actions;
export default staffSlice.reducer;
